import { ImageService } from './../../services/image/image.service'
import { GroupService } from '../../services/group/group.service'
import { IUser } from '../../services/user/user.service'
import { DatePicker } from '@ionic-native/date-picker/ngx'
import { AlertService } from '../../services/alert/alert.service'
import { EventService } from '../../services/event/event.service'
import { UserService } from 'src/app/services/user/user.service'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { IEvent } from 'src/app/services/event/event.service'
import { NavController, Platform } from '@ionic/angular'
import { IGroup } from 'src/app/services/group/group.service'
import { LoadingController } from '@ionic/angular'
import { DEFAULT_BACKGROUND_COLOR } from 'src/app/config'

@Component({
  selector: 'app-event-new',
  templateUrl: './event-new.page.html',
  styleUrls: ['./event-new.page.scss'],
})
export class EventNewPage implements OnInit, OnDestroy {

  user: IUser
  userSubscription: any

  groupList: IGroup[]
  groupListSubscription: any

  event: IEvent
  timestamp: string
  groupId: number
  isAndroid = false
  // isBrowser = false

  backgroundImageStyle: string
  backgroundImage: string = null

  constructor(
    private userService: UserService,
    private eventService: EventService,
    private groupService: GroupService,
    private alert: AlertService,
    private navCtrl: NavController,
    private platform: Platform,
    private datePicker: DatePicker,
    private imgService: ImageService,
    private loadingController: LoadingController
  ) {
    this.userSubscription = this.userService.currentUser.subscribe(value => this.user = value)
    this.groupListSubscription = this.groupService.groupList.subscribe(value => {
      this.groupList = value
      if (value.length === 1)
        this.groupId = value[0].id
    })
    this.backgroundImageStyle = DEFAULT_BACKGROUND_COLOR
    // this.isBrowser = this.imgService.isBrowser
  }

  ngOnInit() {
    this.platform.ready().then(() => {

      if (this.platform.is('android'))
        this.isAndroid = true

      const now = new Date()
      now.setHours(20, 0, 0)

      this.event = {
        id: 0,
        name: '',
        place: '',
        price: '',
        timestamp: now
      }

      this.timestamp = now.toISOString()
    })
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe()
    this.groupListSubscription.unsubscribe()
  }

  ionViewWillLeave() {
    this.imgService.cleanup()
  }

  async createEvent() {
    if (this.event.name === '')
      this.alert.alertPrompt('Bitte trage einen Veranstaltungsnamen ein', 'Warnung')
    else if (!this.groupId)
      this.alert.alertPrompt('Bitte weise eine Gruppe zu', 'Warnung')
    else {
      const loading = await this.loadingController.create({
        message: 'Wird erstellt',
        showBackdrop: true,
        backdropDismiss: false
      })

      await loading.present()

      this.eventService.addEvent(
        this.user.token,
        this.event.name,
        this.event.place,
        this.event.price,
        new Date(this.timestamp),
        this.event.comment,
        this.groupId
      )
        .then(eventId => {
          if (this.backgroundImage !== null) {
            const name = this.imgService.createFilenameFromBase64(this.backgroundImage, Date.now())
            return this.imgService
              // .eventImageUpload(this.user.token, +eventId, this.backgroundImage, timestamp)
              .eventImageUpload(this.user.token, +eventId, this.backgroundImage, name)
              .then(() => this.imgService.saveEventBackground(+eventId, this.backgroundImage, name))
              .catch(err => {
                this.alert.errorHandler(err, 'Das Hintergrundbild konnte nicht hochgeladen werden!')
                return Promise.resolve()
              })
          }
        })
        .then(() => {
          this.backgroundImage = null
          return this.goBack()
        })
        .catch((err) => this.alert.errorHandlerPrompt(err, true))
        .finally(() => loading.dismiss())
    }
  }

  showDatePicker() {
    this.datePicker.show({
      mode: 'datetime',
      is24Hour: true,
      date: new Date(this.event.timestamp),
      androidTheme: this.datePicker.ANDROID_THEMES.THEME_HOLO_LIGHT,
      cancelText: 'Abbrechen',
      okText: 'Fertig',
      cancelButtonLabel: 'Abbrechen',
      doneButtonLabel: 'Fertig',
    })
      .then((date) => {
        this.timestamp = new Date(date).toISOString()
      })
  }

  goBack() {
    return this.navCtrl.navigateRoot('/', { animated: true, animationDirection: 'back' })
  }

  changeBackground(clear = false) {
    if (clear) {
      this.backgroundImageStyle = DEFAULT_BACKGROUND_COLOR
      this.backgroundImage = null
    }
    else {
      this.imgService.getImageFromDevice()
        .then((img: string) => {
          this.backgroundImageStyle = `url(${img}) no-repeat center/cover fixed`
          this.backgroundImage = img
        })
        .catch((err) => this.alert.errorHandler(err, true))
    }
  }

  /* changeBackground(clear = false) {
    if (clear) {
      this.backgroundImageStyle = DEFAULT_BACKGROUND_COLOR
      this.backgroundImage = null
    }
    else {

      // needed for browser version!
      const obs = new MutationObserver(() => {
        const addedElements = document.getElementsByName('files[]')
        for (let i = addedElements.length - 1; i >= 0; i--){
          addedElements[i].setAttribute('style', 'z-index: -1;')
          addedElements[i].setAttribute('accept', 'image/jpeg')
        }

        const input = document.getElementsByName('files[]')[0] as HTMLElement
        if (typeof input !== 'undefined')
          input.click()
      })
      obs.observe(document.body, { childList: true })
      setTimeout(() => {
        obs.disconnect()
      }, 1000)
      // ---

      // if (this.isBrowser)
      //  document.getElementById('fileInput').click()
      // else 

      this.imgService.getPictureFromDevice()
        .then(result => {
          if (typeof result !== 'undefined') {
            const url = this.imgService.urlPathForImage(result)
            this.backgroundImageStyle = `url(${url}) no-repeat center/cover fixed`
            this.backgroundImage = result
          }
        })
        .catch((err) => this.alert.errorHandler(err, true))
    }
  } */

  /* fileInputChangeListener($event) {
    const file = $event.target.files[0]

    return this.imgService.fileToBase64(file)
      .then((base64Image: string) => {
        this.backgroundImageStyle = `url(${base64Image}) no-repeat center/cover fixed`
        this.backgroundImage = {
          name: file.name,
          path: base64Image
        }
      })
      .catch((err) => this.alert.errorHandler(err, true))
  } */
}
